import { DateField } from 'admin';
import { InspectionDTO } from 'api';
import type { DataGridColumn } from 'ui';

import { RISK_SCORE_OPTIONS, RiskScoreChip } from '~/risk';

import { INSPECTION_STATUSES } from '../../components/InspectionMutate/options';
import { InspectionStatusChip } from '../../components/InspectionStatusChip/InspectionStatusChip';

const EMPTY_VALUE = 'N/A';

export const columns: DataGridColumn<InspectionDTO>[] = [
  {
    columnSize: 'small',
    field: 'deal_id',
    filterable: true,
    headerName: 'Deal',
    sortable: true,
    type: 'string',
    valueGetter: (params) => {
      if (!params.row?.deal_id) {
        return EMPTY_VALUE;
      }
      return params.row?.deal_id;
    },
  },
  {
    columnSize: 'large',
    field: 'time',
    filterable: false,
    headerName: 'Time',
    renderCell: (params) => {
      if (!params.value) {
        return EMPTY_VALUE;
      }
      return (
        <DateField
          value={params.value}
          format="LLL"
          sx={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        />
      );
    },
    sortable: true,
  },
  {
    columnSize: 'medium',
    field: 'slug',
    filterable: true,
    headerName: 'Slug',
    sortable: true,
    type: 'string',
  },
  {
    columnSize: 'medium',
    field: 'status',
    filterable: true,
    headerName: 'Status',
    renderCell: (params) => {
      return <InspectionStatusChip status={params.value} />;
    },
    sortable: true,
    type: 'singleSelect',
    valueOptions: INSPECTION_STATUSES,
  },
  {
    columnSize: 'small',
    field: 'loads_count',
    filterable: true,
    headerName: 'Loads',
    sortable: true,
    type: 'string',
  },
  {
    columnSize: 'large',
    field: 'producer',
    filterable: true,
    headerName: 'Producer',
    sortable: true,
    type: 'string',
    valueGetter: (params) => {
      if (!params.row?.producer) {
        return EMPTY_VALUE;
      }
      return params.row?.producer;
    },
  },
  {
    columnSize: 'large',
    field: 'end_processor',
    filterable: true,
    headerName: 'End Processor',
    sortable: true,
    type: 'string',
    valueGetter: (params) => {
      if (!params.row?.end_processor) {
        return EMPTY_VALUE;
      }
      return params.row?.end_processor;
    },
  },
  {
    columnSize: 'small',
    field: 'material',
    filterable: true,
    headerName: 'Material',
    sortable: true,
    type: 'string',
    valueGetter: (params) => {
      if (!params.row?.material) {
        return EMPTY_VALUE;
      }
      return params.row?.material;
    },
  },
  {
    columnSize: 'medium',
    field: 'risk_score',
    filterable: true,
    headerName: 'Risk',
    renderCell: (params) => {
      if (!params.row?.risk_score) {
        return EMPTY_VALUE;
      }
      return <RiskScoreChip riskScore={params.row?.risk_score} />;
    },
    sortable: false,
    type: 'singleSelect',
    valueOptions: RISK_SCORE_OPTIONS,
  },
  {
    columnSize: 'medium',
    field: 'inspection_company',
    filterable: true,
    headerName: 'Company',
    sortable: false,
    type: 'string',
    valueGetter: (params) => {
      if (!params.value) {
        return EMPTY_VALUE;
      }
      return String(params.value.name);
    },
  },
  {
    columnSize: 'medium',
    field: 'inspector',
    filterable: true,
    headerName: 'Inspector',
    sortable: false,
    type: 'string',
    valueGetter: (params) => {
      if (!params.value) {
        return EMPTY_VALUE;
      }

      return String(params.value?.name);
    },
  },
];
